export const VIEW_TYPES = {
  PERSONAL: 'personal',
  SHARED: 'shared',
  GLOBAL: 'global',
};

const ALLOWED_TYPES = Object.values(VIEW_TYPES);

function getValue(view, key) {
  if (!view) return undefined;
  if (typeof view.get === 'function') return view.get(key);
  return view[key];
}

export function resolveViewType(view) {
  const type = getValue(view, 'type');
  if (type && ALLOWED_TYPES.includes(type)) {
    return type;
  }

  const forRights = getValue(view, 'forRights');
  if (typeof forRights === 'boolean') {
    return forRights ? VIEW_TYPES.SHARED : VIEW_TYPES.PERSONAL;
  }

  const forRight = getValue(view, 'forRight');
  if (typeof forRight === 'boolean') {
    return forRight ? VIEW_TYPES.SHARED : VIEW_TYPES.PERSONAL;
  }

  return VIEW_TYPES.PERSONAL;
}

export function isSharedView(view) {
  return resolveViewType(view) === VIEW_TYPES.SHARED;
}

export function isGlobalView(view) {
  return resolveViewType(view) === VIEW_TYPES.GLOBAL;
}
